import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentCardState } from './payment-state.model';

const selectPaymentState = createFeatureSelector<PaymentCardState>('payment');

export const selectPaymentCards = createSelector(selectPaymentState, (state) => state.cards);
